import { render, staticRenderFns } from "./rollback-history.vue?vue&type=template&id=33ac7132&"
import script from "./rollback-history.vue?vue&type=script&lang=js&"
export * from "./rollback-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports